module.exports = __webpack_public_path__ + "static/img/70.810620a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Teams/70.png
// module id = mOv8
// module chunks = 1